import { render, staticRenderFns } from "./CountdownModal.vue?vue&type=template&id=358dcb8d&"
import script from "./CountdownModal.vue?vue&type=script&lang=js&"
export * from "./CountdownModal.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/components/countdown-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports